/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FanRemixContestWinnersSelectedNotificationActionData } from './FanRemixContestWinnersSelectedNotificationActionData';
import {
    FanRemixContestWinnersSelectedNotificationActionDataFromJSON,
    FanRemixContestWinnersSelectedNotificationActionDataFromJSONTyped,
    FanRemixContestWinnersSelectedNotificationActionDataToJSON,
} from './FanRemixContestWinnersSelectedNotificationActionData';

/**
 * 
 * @export
 * @interface FanRemixContestWinnersSelectedNotificationAction
 */
export interface FanRemixContestWinnersSelectedNotificationAction {
    /**
     * 
     * @type {string}
     * @memberof FanRemixContestWinnersSelectedNotificationAction
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof FanRemixContestWinnersSelectedNotificationAction
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof FanRemixContestWinnersSelectedNotificationAction
     */
    timestamp: number;
    /**
     * 
     * @type {FanRemixContestWinnersSelectedNotificationActionData}
     * @memberof FanRemixContestWinnersSelectedNotificationAction
     */
    data: FanRemixContestWinnersSelectedNotificationActionData;
}

/**
 * Check if a given object implements the FanRemixContestWinnersSelectedNotificationAction interface.
 */
export function instanceOfFanRemixContestWinnersSelectedNotificationAction(value: object): value is FanRemixContestWinnersSelectedNotificationAction {
    let isInstance = true;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function FanRemixContestWinnersSelectedNotificationActionFromJSON(json: any): FanRemixContestWinnersSelectedNotificationAction {
    return FanRemixContestWinnersSelectedNotificationActionFromJSONTyped(json, false);
}

export function FanRemixContestWinnersSelectedNotificationActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): FanRemixContestWinnersSelectedNotificationAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specifier': json['specifier'],
        'type': json['type'],
        'timestamp': json['timestamp'],
        'data': FanRemixContestWinnersSelectedNotificationActionDataFromJSON(json['data']),
    };
}

export function FanRemixContestWinnersSelectedNotificationActionToJSON(value?: FanRemixContestWinnersSelectedNotificationAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specifier': value.specifier,
        'type': value.type,
        'timestamp': value.timestamp,
        'data': FanRemixContestWinnersSelectedNotificationActionDataToJSON(value.data),
    };
}

